import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdatePortfolioPage($companyId: ID!, $id: ID!, $attributes: PortfolioPageAttributes!) {
    updatePortfolioPage(companyId: $companyId, id: $id, attributes: $attributes) {
      portfolioPage {
        id
        ...UpdatedPortfolioPage
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedPortfolioPage on PortfolioPage {
    id
    slug
    title
    body
    description
    enabled
    event { id }
  }
`
